"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effects = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const Slider_1 = require("../../components/Slider");
const Stroke_1 = require("../Stroke");
const Effects_style_1 = require("./Effects.style");
function Effects({ onUpdate, labels, textEffects: textEffectsProps, strokeOptions, }) {
    const theme = (0, styled_components_1.useTheme)();
    const [textEffects, setTextEffects] = (0, react_1.useState)({});
    const [textEffectsActive, setTextEffectsActive] = (0, react_1.useState)({});
    (0, react_1.useEffect)(function updateEffectWhenPropChanges() {
        setTextEffects(textEffectsProps
            .filter((effect) => !effect.data.hide)
            .reduce((acc, effect) => {
            acc[effect.type] = Object.assign({}, effect);
            return acc;
        }, {}));
        setTextEffectsActive(textEffectsProps
            .filter((effect) => !effect.data.hide)
            .reduce((acc, effect) => {
            var _a, _b, _c, _d;
            switch (effect.type) {
                case 'underline':
                    acc[effect.type] = !!effect.data.value;
                    break;
                case 'highlight':
                    acc[effect.type] =
                        ((_a = effect.data) === null || _a === void 0 ? void 0 : _a.color) && ((_b = effect.data) === null || _b === void 0 ? void 0 : _b.color) !== 'NONE';
                    break;
                case 'lineThrough':
                    acc[effect.type] = !!effect.data.value;
                    break;
                case 'stroke':
                    acc[effect.type] =
                        ((_c = effect.data) === null || _c === void 0 ? void 0 : _c.width) && ((_d = effect.data) === null || _d === void 0 ? void 0 : _d.width.value) !== '0';
                    break;
                default:
                    acc[effect.type] = !!effect.data;
            }
            return acc;
        }, {}));
    }, [textEffectsProps]);
    const toggleEffect = (0, react_1.useCallback)((type) => {
        switch (type) {
            case 'underline':
                setTextEffectsActive((prev) => {
                    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
                        data: !prev['underline'],
                        action: textEffects['underline'].action,
                    });
                    return Object.assign(Object.assign({}, prev), { underline: !prev['underline'], lineThrough: false });
                });
                break;
            case 'highlight':
                setTextEffectsActive((prev) => {
                    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
                        data: !prev['highlight']
                            ? textEffects['highlight'].data
                            : {
                                color: 'none',
                            },
                        action: textEffects['highlight'].action,
                    });
                    return Object.assign(Object.assign({}, prev), { [type]: !prev[type] });
                });
                break;
            case 'lineThrough':
                setTextEffectsActive((prev) => {
                    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
                        data: !prev['lineThrough'],
                        action: textEffects['lineThrough'].action,
                    });
                    return Object.assign(Object.assign({}, prev), { lineThrough: !prev['lineThrough'], underline: false });
                });
                break;
            case 'stroke':
                setTextEffectsActive((prev) => {
                    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
                        data: !prev['stroke']
                            ? textEffects['stroke'].data
                            : Object.assign(Object.assign({}, textEffects['stroke'].data), { width: { value: 0 } }),
                        action: textEffects['stroke'].action,
                    });
                    return Object.assign(Object.assign({}, prev), { [type]: !prev[type] });
                });
                break;
            default:
                setTextEffectsActive((prev) => {
                    return Object.assign(Object.assign({}, prev), { [type]: !prev[type] });
                });
        }
    }, [onUpdate, textEffects]);
    const handleEffects = (0, react_1.useCallback)((effect, action = effect.action) => {
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({ data: effect.data, action: action });
        setTextEffects((prev) => (Object.assign(Object.assign({}, prev), { [effect.type]: Object.assign({}, effect) })));
    }, [onUpdate]);
    const { t } = (0, ui_common_translation_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Effects_style_1.StyledColumnContainer, { children: [(0, jsx_runtime_1.jsxs)(Effects_style_1.StyledTitle, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: "effects", color: theme.Color.Neutrals.Dark }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", color: theme.Color.Neutrals.Dark, children: t(`${labels.title}`) })] }), (0, jsx_runtime_1.jsx)(Effects_style_1.StyledEffectsContainer, { children: Object.values(textEffects).map((effect) => {
                    var _a, _b;
                    return ((0, jsx_runtime_1.jsx)(Effects_style_1.StyledEffectElement, { variant: (_a = effect.type) !== null && _a !== void 0 ? _a : 'none', active: textEffectsActive[effect.type], onClick: () => toggleEffect(effect.type), children: (0, jsx_runtime_1.jsx)(Effects_style_1.StyledEffectIcon, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: (_b = effect.icon) !== null && _b !== void 0 ? _b : '' }) }) }, effect.type));
                }) }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Divider, {}), textEffectsActive['stroke'] && ((0, jsx_runtime_1.jsxs)(Effects_style_1.StyledOptionContainer, { children: [(0, jsx_runtime_1.jsx)(Stroke_1.StrokeGrid, { options: strokeOptions, strokeType: textEffects['stroke'].data.dashArray, handleStrokeType: (type) => handleEffects(Object.assign(Object.assign({}, textEffects['stroke']), { data: Object.assign(Object.assign({}, textEffects['stroke'].data), { dashArray: (type === null || type === void 0 ? void 0 : type.dashArray) || '' }) }), 'set-text-stroke-dash-array') }), (0, jsx_runtime_1.jsxs)(Effects_style_1.StyledEffectOptionsContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", children: labels.strokeWeight }), (0, jsx_runtime_1.jsx)(Slider_1.Slider, { id: "section-effects-stroke-weight", variant: "section", value: Number(textEffects['stroke'].data.width.value), minValue: textEffects['stroke'].data.width.min, maxValue: textEffects['stroke'].data.width.max, onUpdate: (weight) => handleEffects(Object.assign(Object.assign({}, textEffects['stroke']), { data: Object.assign(Object.assign({}, textEffects['stroke'].data), { width: Object.assign(Object.assign({}, textEffects['stroke'].data.width), { value: weight }) }) }), 'set-text-stroke-width') })] }), (0, jsx_runtime_1.jsxs)(Effects_style_1.StyledColorContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", children: labels.strokeColor }), (0, jsx_runtime_1.jsx)(ui_common_components_1.ColorBullet, { color: !textEffects['stroke'].data.color ||
                                    textEffects['stroke'].data.color.toLowerCase() === 'none'
                                    ? 'transparent'
                                    : textEffects['stroke'].data.color, onChange: (value) => handleEffects(Object.assign(Object.assign({}, textEffects['stroke']), { data: Object.assign(Object.assign({}, textEffects['stroke'].data), { color: value }) }), 'set-text-stroke-color') })] }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Divider, {})] })), textEffectsActive['highlight'] && ((0, jsx_runtime_1.jsxs)(Effects_style_1.StyledOptionContainer, { children: [(0, jsx_runtime_1.jsxs)(Effects_style_1.StyledColorContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", children: labels.highlightColor }), (0, jsx_runtime_1.jsx)(ui_common_components_1.ColorBullet, { color: !textEffects['highlight'].data.color ||
                                    textEffects['highlight'].data.color.toLowerCase() === 'none'
                                    ? 'transparent'
                                    : textEffects['highlight'].data.color, onChange: (value) => handleEffects(Object.assign(Object.assign({}, textEffects['highlight']), { data: Object.assign(Object.assign({}, textEffects['highlight'].data), { color: value }) }), 'set-text-highlight-color') })] }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Divider, {})] }))] }));
}
exports.Effects = Effects;
//# sourceMappingURL=Effects.js.map